module.exports = new __parcel__URL__("super_swole_squad_department_level_1.48d71e36.png").toString();